import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { getTag } from '../../../app/_core/_utils/get-tag';

export const tagInterceptor: HttpInterceptorFn = (req, next) => {
  // Le chiamate PVGIS devono uscire "pulite" da header applicativi.
  if (req.url.startsWith('/pvgis')) {
    return next(req);
  }

  // se l’URL comincia con uno dei domini esclusi -> bypass
  const isExcluded = environment.excludedDomains.some((domain) =>
    req.url.startsWith(domain),
  );

  if (isExcluded) {
    return next(req);
  }

  try {
    let tag = getTag();

    // Se ho un tag valido, clono la richiesta con l'header x-hasura-tag
    if (tag) {
      const cloned = req.clone({
        headers: req.headers.append('x-hasura-tag', tag),
      });
      return next(cloned);
    }
  } catch (e) {
    console.warn('tagInterceptor: URL non valido o non gestito', e);
  }

  // Nessuna modifica
  return next(req);
};
